import type { FaireProductEntity } from "../../entity_types/product";

export const p_vr88sk564u: FaireProductEntity = {
  token: "p_vr88sk564u",
  type: "product",
  name: "Flameless Rechargeable Lighter | Duo-Tone Coloways",
  brandToken: "b_b19tidse3g",
  brandName: "BOTANICA",
  imageUrl:
    "https://cdn.faire.com/fastly/cdc40204bcc985091ed81503f274e4cb6a5280a50f0f8a0c785f6e6b999198f8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a7b6fd53ca5a74249960dc4aeed226af3cf70e4654da58b9289b04dcb7349eeb.jpeg",
    "https://cdn.faire.com/fastly/e797d0944c6a105e59411467058230e98a76a34067b6ea8b5d100c042e9dee6b.jpeg",
    "https://cdn.faire.com/fastly/d62639898836763dee9e4f4e6ab2d00654fd164f7b038b8605ceb57d211b0307.jpeg",
    "https://cdn.faire.com/fastly/7f91bf79b4347c05c79bfdc0e6eb69789d067ac6f6b458a4055d7b0e8aa771f1.jpeg",
    "https://cdn.faire.com/fastly/810b024d95dc90476e379f707ed359dfefd79e2eb1bce4cc3639a6d16d1634b9.jpeg",
    "https://cdn.faire.com/fastly/7cf790b184808353aca47663d3810cac1c14e6c821037b7224cc0a0ed5df9998.jpeg",
    "https://cdn.faire.com/fastly/23575dd2161d55353061973f9e9f4ea153bb73fcde350b90b4b420ff016b0435.jpeg",
    "https://cdn.faire.com/fastly/3ad6430c08a61cc21327312a5765222d6044f53805fb2d5f0488cdbb574737bd.jpeg",
    "https://cdn.faire.com/fastly/7b8141c0dcd6811d5db697ca7455fa9039bec29f74c94698d088c4dadbbf808f.jpeg",
    "https://cdn.faire.com/fastly/36a34ea4883bf5d558aaddc611ae72ea02881f0f22cbab80dcc5eda1be431f2c.jpeg",
    "https://cdn.faire.com/fastly/87be3c637655dd2591ee262438524d41c8e9ec1fda0c43b3f854a54e1efa5464.jpeg",
  ],
  priceDollars: 16,
  description:
    'Get lit! Our Flameless Lighters utilize single ARC technology, making for a clean, butane-free ignition for every candle lighting (and more!) Our Flameless lighters recharge through a convenient USB port. A safety switch is included to make accidental lights a non-issue. Packed in a colorful gift box with a 5" USB-C cable, these are a thoughtful & handy addition for candle gifting.\n\nPackaged in Gift Box, includes Charging Cord + Instructions/Safety Sheet.\n\nAvailable in 8 Colorways:\nPoppy: Vermillion + Peach\nEarth: Blue + Green\nSherbet: Melon + Lemonlime\nBlue Moon: Lilac + Periwinkle Blue\nOceana: Aqua + Dark Teal\nNeutral: White + Taupe\nBeverly Hills: Pink + Green\nMartini Olive: Chartreuse + Magenta\n\n\n\n\n\nKeywords for your SEO:\nlighter, usb lighter, rechargeable, green gifts, eco gifts, reusable, matches, candle gifts, hostess gifts, best seller, best selling, boutique gifts, quality gift, giftshop, botanica, reuse',
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:36:26.947Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
